import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
export const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-81">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 100
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 100
    }} className="fixed bottom-0 left-0 w-full z-40 p-4 bg-gradient-to-t from-night-900 via-night-900/90 to-transparent md:hidden" data-id="element-82">
          <Button href="#compra" fullWidth className="shadow-[0_0_30px_rgba(108,99,255,0.3)] !py-3" data-id="element-83">
            COMPRAR — $19.990
          </Button>
        </motion.div>}
    </AnimatePresence>;
};